import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-note-card',
  templateUrl: './operation-note-card.component.html',
  styleUrls: ['./operation-note-card.component.scss']
})
export class OperationNoteCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
